import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

const XIcon = ({ size = 24, color = '#EA4335' }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <Defs>
      <ClipPath id="clip0_x">
        <Rect width="24" height="24" fill="white" />
      </ClipPath>
    </Defs>
    <G clipPath="url(#clip0_x)">
      <Path
        d="M18.75 5.25L5.25 18.75"
        stroke={color}
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M18.75 18.75L5.25 5.25"
        stroke={color}
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
  </Svg>
);

export default XIcon;
